
export const ReportScheduleIntervals = Object.freeze({
    "Daily": "Daily",
    "Weekly": "Weekly",
    "Monthly": "Monthly",
    "Annuallly": "Annually"
})